import * as actions from './actions';

export type State = {};

export default (state: State = {}, action: any): State => {
  switch (action.type) {
    case actions.LOAD_CONFIG:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
